import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, Stack, Typography, FormControl, FormLabel, Input, Button, Alert } from '@mui/joy';
import { useAdmin } from '../../contexts/Admin.tsx';

export default function AdminLogin() {
  const { api, setAuthenticated } = useAdmin();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.login(username, password);
      setAuthenticated(true);
      navigate('/admin', { replace: true });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Card sx={{ width: '100%', maxWidth: 400, p: 4 }}>
        <Stack spacing={2}>
          <Typography level="h3">Admin Sign In</Typography>
          {error && <Alert color="danger" variant="soft">{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <FormControl required>
                <FormLabel>Username</FormLabel>
                <Input value={username} onChange={e => setUsername(e.target.value)} disabled={loading} autoFocus />
              </FormControl>
              <FormControl required>
                <FormLabel>Password</FormLabel>
                <Input type="password" value={password} onChange={e => setPassword(e.target.value)} disabled={loading} />
              </FormControl>
              <Button type="submit" loading={loading} fullWidth>Sign In</Button>
            </Stack>
          </form>
        </Stack>
      </Card>
    </Box>
  );
}
